import { apiHelper } from './api_helper';

export const COSO_API_ENDPOINT ='co-so';
export const coSoApi = {
    SelectAll : ()=> apiHelper.get(COSO_API_ENDPOINT),
    SelectByTruong: (dm_truong_id) => apiHelper.get(`truong/${dm_truong_id}/co-so`),
    Detail: (id) => apiHelper.get(`${COSO_API_ENDPOINT}/${id}`),
    Insert : (data) => apiHelper.post(COSO_API_ENDPOINT,data),
    Update: (data)=> apiHelper.put(COSO_API_ENDPOINT, data),
    Delete: (id)=> apiHelper.delete(`${COSO_API_ENDPOINT}/${id}`)
}